import { useMutation, useQuery } from "@tanstack/react-query";
import { useAlert } from "context/alert";
import { useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import {
  createDocumentUpload,
  fetchDocumentTypeList,
} from "services/newRegistration";
import { STALE_TIME } from "utils/constants";
import zoneLocalStorageId from "utils/zone";

const UploadDocument = ({
  onClose,
  rowData,
  setdocumentInfo,
  setDocumentModal,
  docmentAppointmentBookingId,
}) => {
  const { showAlert } = useAlert();
  const [selectedOption, setSelectedOption] = useState(null);
  const [required, setRequired] = useState(false);
  const [file, setFile] = useState(null);
  const [fileRequired, setFileRequired] = useState(false);
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const rawSub = jwtAuthreducer?.token_values?.sub;

  let _token = null;
  try {
    if (rawSub) {
      const fixed = rawSub
        .replace(/'/g, '"')
        .replace(/\bNone\b/g, "null")
        .replace(/\bTrue\b/g, "true")
        .replace(/\bFalse\b/g, "false");

      _token = JSON.parse(fixed);
    }
  } catch (e) {
    console.error("Failed to parse token_values.sub", e);
  }
  console.log(
    "jwtAuthreducer",
    jwtAuthreducer?.user?.franchise_ids[0]?.franchise_id
  );

  const [fileData, setFileData] = useState("");
  const [filePath, setFilePath] = useState("");
  const [fileName, setFileName] = useState("");

  const { data } = useQuery(
    ["fetch-document-type"],
    () => fetchDocumentTypeList(),
    {
      staleTime: STALE_TIME,
      onSuccess: (res) => {},
      onError: (err) => {
        showAlert("Failed to fetch document!", "danger");
      },
    }
  );

  const options =
    data?.data?.data?.map((item) => ({
      value: item.id,
      label: item.document_name,
    })) || [];

  const handleChange = (selected) => {
    setSelectedOption(selected);
    setRequired(!selected);
  };

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    setFile(selectedFile);
    setFileName(selectedFile.name);
    setFilePath(selectedFile.name);

    const reader = new FileReader();
    reader.readAsDataURL(selectedFile);
    reader.onload = () => {
      setFileData(reader.result);
    };
    reader.onerror = (error) => {
      console.error("Error converting file to base64:", error);
    };

    setFileRequired(!selectedFile);
  };

  const onSuccess = (res) => {
    setdocumentInfo(res);
    setDocumentModal(false);
    showAlert("Document uploaded successfully!", "success");
  };

  const onError = (res) => {
    showAlert("Failed to upload document!", "danger");
  };

  const { mutate: addDocumentMutate } = useMutation({
    mutationFn: createDocumentUpload,
    onSuccess,
    onError,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedOption) {
      setRequired(true);
    }
    if (!file) {
      setFileRequired(true);
    }
    const cleanedFileData = fileData.replace(
      /^data:application\/pdf;base64,/,
      ""
    );

    if (selectedOption && file) {
      const payload = {
        document_id: selectedOption.value,
        file_name: fileName,
        file_path: filePath,
        file_data: cleanedFileData,
        franchise_id: jwtAuthreducer?.user?.franchise_ids[0]?.franchise_id,
        appointment_booking_id: docmentAppointmentBookingId,
        zone_id: zoneLocalStorageId(),
        is_active: true,
        created_by: jwtAuthreducer.user.employee_code_id,
      };

      if (payload) {
        addDocumentMutate(payload);
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label className="form-label">
          Document Type <span className="alertColor">*</span>
        </label>
        <Select
          options={options}
          value={selectedOption}
          onChange={handleChange}
          isClearable
          placeholder="---Document Type---"
          classNamePrefix="react-select"
          className={`react-select-container ${required ? "is-invalid" : ""}`}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
        {required && <div className="text-danger">This field is required</div>}
      </div>

      <div className="mt-3">
        <label className="form-label">
          Upload Document <span className="alertColor">*</span>
        </label>
        <input
          type="file"
          className={`form-control ${fileRequired ? "is-invalid" : ""}`}
          onChange={handleFileChange}
          accept=".pdf,image/*"
        />
        {fileRequired && <div className="text-danger">File is required</div>}
      </div>

      <div className="mt-4 d-flex justify-content-start">
        <button type="submit" className="btn btn-primary">
          Upload
        </button>
      </div>
    </form>
  );
};

export default UploadDocument;
